'use client';

type PillVariant = 'green' | 'amber' | 'red' | 'blue';

interface StatusPillProps {
  variant: PillVariant;
  children: React.ReactNode;
}

export function StatusPill({ variant, children }: StatusPillProps) {
  return (
    <span className={`pub-pill pub-pill-${variant}`}>
      {children}
    </span>
  );
}
